import React from 'react';
import { Modal } from '../../../common/sharedComponents/Modal';
import { Question, Tag } from './styled.questionCard';
import { IAttachmentModal } from '../../../../app/@types/questionCard';

export function AttachmentModal ({
  isModalOpen,
  handleOpenModalImg,
  question,
}: IAttachmentModal) {
  return (
    <Modal
      isOpen={isModalOpen}
      handleModalClose={handleOpenModalImg}
      imageUrl={question.attachment && question.attachment.url}
      isShowCloseIcon={true}
    >
      <Tag>{question.performanceClassification}</Tag>
      <Question>{question.text}</Question>
    </Modal>
  );
}
